import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/invite/dnd-box.png'
import _imports_1 from '@/assets/img/invite/copy-dark.png'
import _imports_2 from '@/assets/img/invite/copy.png'
import _imports_3 from '@/assets/img/invite/app-store.png'
import _imports_4 from '@/assets/img/invite/app-store-light.png'
import _imports_5 from '@/assets/img/invite/back.png'
import _imports_6 from '@/assets/img/invite/android.png'
import _imports_7 from '@/assets/img/invite/android-light.png'


const _hoisted_1 = { class: "invite_landing" }
const _hoisted_2 = { class: "invite_landing_content" }
const _hoisted_3 = { class: "invite_title" }
const _hoisted_4 = { class: "invite_sub_title" }
const _hoisted_5 = { class: "invite_step" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "invite_method" }
const _hoisted_9 = { class: "invite_method-title" }
const _hoisted_10 = { class: "invite_method-card" }
const _hoisted_11 = { class: "invite_method-card-input" }
const _hoisted_12 = { class: "invite_method-card-input-copy" }
const _hoisted_13 = { class: "invite_dowload" }
const _hoisted_14 = { class: "invite_dowload-title" }
const _hoisted_15 = { class: "invite_dowload-card" }
const _hoisted_16 = { class: "invite_dowload-card-item-left" }
const _hoisted_17 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_18 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_19 = { style: {
                    display: 'flex',
                    flexDirection: 'column',
                  } }
const _hoisted_20 = { class: "desc" }
const _hoisted_21 = { class: "invite_dowload-card-item-left" }
const _hoisted_22 = {
  key: 0,
  src: _imports_6,
  alt: ""
}
const _hoisted_23 = {
  key: 1,
  src: _imports_7,
  alt: ""
}

import useDownloadApp from '@/hooks/useDownloadApp'
  import Header from '@/components/header.vue'
  import i18n from '@/language'
  import { useClipboard, useDark } from '@vueuse/core'
  import { message } from 'ant-design-vue'
  import { computed, onMounted, ref, watchEffect } from 'vue'
  import { useRoute } from 'vue-router'
  import useOpenApp from '@/hooks/useOpenApp'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const route = useRoute()

  const code = computed(() => route.query?.id as string)

  const { downloadApp } = useDownloadApp()

  const { openApp } = useOpenApp()

  const isDark = useDark({
    selector: 'html',
    attribute: 'data-theme',
    valueDark: 'dark',
    valueLight: 'light',
  })

  const { copy, copied } = useClipboard({})

  watchEffect(() => {
    if (copied.value) {
      // @ts-ignore
      message.success(i18n.global.t('复制成功'))
    }
  })

  const stepList = ref([
    {
      numberImg: require('@/assets/img/invite/number-1.png'),
      img: require('@/assets/img/invite/step-1.png'),
      text: '下载 Envo',
    },
    {
      numberImg: require('@/assets/img/invite/number-2.png'),
      img: require('@/assets/img/invite/step-2.png'),
      text: '点击 [我的]',
    },
    {
      numberImg: require('@/assets/img/invite/number-3.png'),
      img: require('@/assets/img/invite/step-3.png'),
      text: '点击 [邀请奖励]',
    },
    {
      numberImg: require('@/assets/img/invite/number-4.png'),
      img: require('@/assets/img/invite/step-4.png'),
      text: '填写邀请码',
    },
  ])

  onMounted(() => {
    if (route.query?.id) {
      openApp()
    }

    if (route.query.theme === 'dark') {
      isDark.value = true
    } else {
      isDark.value = false
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createElementVNode("img", {
        class: "invite_dnd_box",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('来Envo一起赚DND')), 1),
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t('一站式服务链接WEB3')), 1),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('引领您探索数字新纪元')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "invite_step_item",
              key: index
            }, [
              _createElementVNode("img", {
                class: "invite_step_item-number",
                src: item.numberImg
              }, null, 8, _hoisted_6),
              _createElementVNode("img", {
                class: "invite_step_item-img",
                src: item.img
              }, null, 8, _hoisted_7),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.text)), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('邀请码')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('邀请码')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(code.value || '-'), 1),
                (_unref(isDark))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copy)(code.value)))
                    }))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_2,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copy)(code.value)))
                    }))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('下载Envo')), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "invite_dowload-card-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(downloadApp)({ channelCode: 'Envo', invite: code.value })))
            }, [
              _createElementVNode("div", _hoisted_16, [
                (_unref(isDark))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                  : (_openBlock(), _createElementBlock("img", _hoisted_18)),
                _createElementVNode("div", _hoisted_19, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "App Store", -1)),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('需 AppStore 非中国大陆账户')), 1)
                ])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("img", { src: _imports_5 }, null, -1))
            ]),
            _createElementVNode("div", {
              class: "invite_dowload-card-item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(downloadApp)({ channelCode: 'Envo', invite: code.value })))
            }, [
              _createElementVNode("div", _hoisted_21, [
                (_unref(isDark))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                  : (_openBlock(), _createElementBlock("img", _hoisted_23)),
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Android", -1))
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("img", { src: _imports_5 }, null, -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})